import { combineReducers } from '@reduxjs/toolkit'

import incidentReducer from './incident'

const combinedReducer = combineReducers({
  disciplineIncident: incidentReducer,
})

export default combinedReducer
